/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12a.75.75 0 0 1 1.5 0c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0a.75.75 0 0 1 0 1.5Z"
    />
    <path
      fill="currentColor"
      d="M12.9319 5.3138A6.8102 6.8102 0 0 0 12 5.25c-3.728 0-6.75 3.022-6.75 6.75 0 3.7279 3.022 6.75 6.75 6.75 3.7279 0 6.75-3.0221 6.75-6.75 0-.3162-.0217-.6274-.0638-.932h-2.5723l-2.523 2.523c-.8787.8786-2.3033.8786-3.182 0-.8787-.8787-.8787-2.3033 0-3.182l2.523-2.523V5.3138Z"
    />
    <path
      fill="currentColor"
      d="M14.4319 4.9718v3.5356l-2.9623 2.9623a.75.75 0 0 0 1.0607 1.0606l2.9623-2.9623h3.5355l4.5832-4.5831c.504-.504.1471-1.3657-.5657-1.3657h-2.6648V.9544c0-.7128-.8617-1.0697-1.3657-.5657l-4.5832 4.5831Z"
    />
  </React.Fragment>,
  'MenuOperationalInsightsFilled'
);
